<template>
  <div>
    <ServiceScreenLayout :parts="parts">
      <template v-slot:main>
          <PricingFilterToolbar
            :search-term="mainSearchTerm"
            :expired-filter="mainExpiredFilter"
            search-placeholder="Search by Description or Label..."
            @search-change="mainSearchTerm = $event"
            @expired-filter-change="mainExpiredFilter = $event"
          >
            <template v-slot:actions>
              <button
                v-if="userEditRight"
                type="button"
                class="btn btn-info mr-3 mb-2"
                @click="createNewPackage()"
              >
                Create New Package
              </button>
            </template>
          </PricingFilterToolbar>
          <div class="row row-spacing mb-3">
            <div class="col-md-12">
              <div
                class="table-responsive table-bordered"
                v-if="mainPackages.length > 0"
              >
                <table class="table pricing-table">
                  <thead>
                    <tr class="text-nowrap">
                      <th class="pricing-column-description">Description</th>
                      <th class="pricing-column-label">Label</th>
                      <th class="pricing-column-count">Concurrent Calls</th>
                      <th class="pricing-column-price">MRC (excl. VAT)</th>
                      <th class="pricing-column-status">Expired</th>
                      <th class="pricing-column-services">Services</th>
                      <th class="pricing-column-actions"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="{ 'bg-primary': cx3Package.expired }"
                      v-for="cx3Package in mainPackages"
                      :key="cx3Package.cx3CloudPbxPackageNumber"
                    >
                      <td>{{ cx3Package.description }}</td>
                      <td class="pricing-column-label">{{ cx3Package.label }}</td>
                      <td class="text-nowrap" style="width: 10%">
                        {{ cx3Package.concurrentCalls }}
                      </td>
                      <td style="width: 20%">
                        {{ getPrice(cx3Package.prices, period) }}
                        <span
                          v-if="userEditRight"                  
                          style="cursor: pointer"
                          @click="openPriceModal(cx3Package)"
                          v-tooltip="'Edit Row Price'"
                          class="pull-right"
                        >
                          <em class="fa fa-edit fa-fw text-green"></em>
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            cx3Package.expired ? 'badge-warning' : 'badge-green'
                          "
                          >{{ cx3Package.expired }}
                        </span>
                      </td>
                      <td class="text-nowrap text-center">
                          <strong>
                            <span class="font-size">{{ packageAmount(cx3Package) }}</span>
                          </strong>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="userEditRight"                  
                          v-tooltip="'Edit Package'"
                          @click="editPackage(cx3Package)"
                          type="button"
                          class="btn btn-sm btn-info m-1"
                        >
                          <em class="fa fa-edit fa-fw"></em>
                        </button>
                        <button
                          v-if="userEditRight"                  
                          v-tooltip="'Delete Package'"
                          type="button"
                          @click="deletePackage(cx3Package)"
                          class="btn btn-sm btn-primary"
                        >
                          <em class="fa fa-trash fa-fw"></em>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="alert alert-info">No 3CX Packages to Display</div>
            </div>
          </div>
          <ModifyCx3PackageModal
            ref="modifyPackageModal"
            :pricePackage="pricePackage"
            @packageAdded="packageAdded"
            @packageEdited="loadCx3Packages()"
          />
          <AddPriceModal
            ref="addPriceModal"
            :row-price="rowPrice"
            :new-price="newPrice"
            @addPrice="addPrice"
            @pricesAdded="loadCx3Packages()"
          />
      </template>
      <template v-slot:support>
        <PricingFilterToolbar
          :search-term="supportSearchTerm"
          :expired-filter="supportExpiredFilter"
          search-placeholder="Search by Description or Label..."
          @search-change="supportSearchTerm = $event"
          @expired-filter-change="supportExpiredFilter = $event"
        >
          <template v-slot:actions>
            <button
              v-if="userEditRight"
              type="button"
              class="btn btn-info mr-3 mb-2"
              @click="createNewSupport()"
            >
              Create New Support Package
            </button>
          </template>
        </PricingFilterToolbar>
          <div class="row row-spacing mb-3">
            <div class="col-md-12">
              <div
                class="table-responsive table-bordered"
                v-if="supportPackages.length > 0"
              >
                <table class="table pricing-table">
                  <thead>
                    <tr class="text-nowrap">
                      <th class="pricing-column-description">Description</th>
                      <th class="pricing-column-label">Label</th>
                      <th class="pricing-column-price">MRC (excl. VAT)</th>
                      <th class="pricing-column-status">Expired</th>
                      <th class="pricing-column-services">Services</th>
                      <th class="pricing-column-actions"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="{ 'bg-primary': support.expired }"
                      v-for="support in supportPackages"
                      :key="support.pbxSupportPackageNumber"
                    >
                      <td>{{ support.description }}</td>
                      <td class="pricing-column-label">{{ support.label }}</td>
                      <td>
                        {{ getPrice(support.prices, period) }}
                        <span
                          v-if="userEditRight"                  
                          style="cursor: pointer"
                          @click="openSupportPriceModal(support)"
                          v-tooltip="'Edit Row Price'"
                          class="pull-right"
                        >
                          <em class="fa fa-edit fa-fw text-green"></em>
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            support.expired ? 'badge-warning' : 'badge-green'
                          "
                          >{{ support.expired }}
                        </span>
                      </td>
                      <td class="text-nowrap text-center">
                          <strong>
                            <span class="font-size">{{ supportAmount(support) }}</span>
                          </strong>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="userEditRight"                  
                          v-tooltip="'Edit Package'"
                          @click="editSupport(support)"
                          type="button"
                          class="btn btn-sm btn-info m-1"
                        >
                          <em class="fa fa-edit fa-fw"></em>
                        </button>
                        <button
                          v-if="userEditRight"                  
                          v-tooltip="'Delete Package'"
                          type="button"
                          @click="deletePackage(support)"
                          class="btn btn-sm btn-primary"
                        >
                          <em class="fa fa-trash fa-fw"></em>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="alert alert-info">No Support Packages to Display</div>
            </div>
          </div>
          <ModifyCx3SupportPackageModal
            ref="modifySupportPackageModal"
            :pricePackage="priceSupportPackage"
            @packageAdded="supportAdded"
            @packageEdited="loadCx3Supports()"
          />
          <AddPriceModal
            ref="addSupportPriceModal"
            :row-price="rowSupportPrice"
            :new-price="newSupportPrice"
            @addPrice="addSupportPrice"
            @pricesAdded="loadCx3Supports()"
          />
      </template>
    </ServiceScreenLayout>
  </div>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";

import PriceFunctions from "@/components/Admin/PriceFunctions";
import AddPriceModal from "@/components/Admin/Modals/AddPriceModal";
import ModifyCx3PackageModal from "@/components/Admin/Modals/ModifyCx3PackageModal";
import ModifyCx3SupportPackageModal from "@/components/Admin/Modals/ModifyCx3SupportPackageModal";
import PricingFilterToolbar from "@/components/Admin/PricingFilterToolbar";

export default {
  extends: PriceFunctions,
  components: {
      ServiceScreenLayout,
      ModifyCx3PackageModal,
      ModifyCx3SupportPackageModal,
      AddPriceModal,
      PricingFilterToolbar,
  },
  props: {
    productNumber: {
      type: Number,
      required: true,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      parts: [
        {
          name: "main",
          icon: "fa fa-archive",
          displayName: "Main Packages",
          permissions: ["STAFF"],
        },
        {
          name: "support",
          icon: "fa fa-plus",
          displayName: "Support Packages",
          permissions: ["STAFF"],
        },
      ],
      cx3Packages: [],
      cx3Supports: [],

      rowPrice: [],
      rowSupportPrice: [],

      pricePackage: {},
      priceSupportPackage: {},

      newPrice: {},
      newSupportPrice: {},

      cx3PackageData: [],
      cx3SupportData: [],

      period: this.getCurrentPeriod(),
      mainExpiredFilter: "false",
      supportExpiredFilter: "false",
      mainSearchTerm: "",
      supportSearchTerm: "",
    };
  },
  mounted() {
    this.loadCx3Packages();
    this.loadCx3Supports();
  },
  computed: {
    mainPackages() {
      return this.filterPricingPackages(
        this.cx3Packages,
        this.mainExpiredFilter,
        this.mainSearchTerm,
        ["concurrentCalls"]
      );
    },
    supportPackages() {
      return this.filterPricingPackages(
        this.cx3Supports,
        this.supportExpiredFilter,
        this.supportSearchTerm
      );
    },
  },
  methods: {
    filterPricingPackages(packages, expiredFilter, searchTerm, extraFields = []) {
      let filteredPackages = packages;

      if (expiredFilter === "false") {
        filteredPackages = filteredPackages.filter((pkg) => pkg.expired === false);
      } else if (expiredFilter === "true") {
        filteredPackages = filteredPackages.filter((pkg) => pkg.expired === true);
      }

      if (searchTerm) {
        const normalizedSearchTerm = searchTerm.toLowerCase();
        filteredPackages = filteredPackages.filter((pkg) =>
          [pkg.description, pkg.label, ...extraFields.map((field) => pkg[field])]
            .filter((value) => value !== null && value !== undefined && value !== "")
            .some((value) =>
              String(value).toLowerCase().includes(normalizedSearchTerm)
            )
        );
      }

      return filteredPackages;
    },
    loadCx3Packages() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/packages/product/" +
            this.productNumber + "/Cx3CloudPbxPackage"
        )
        .then(
          (response) => {
            this.cx3Packages = response.data;
            this.getServiceAmounts(this.cx3Packages, "main");
            this.setNewPrice();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching 3CX Packages", error);
          }
        );
    },
    loadCx3Supports() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/packages/product/" +
            this.productNumber + "/PbxSupportPackage"
        )
        .then(
          (response) => {
            this.cx3Supports = response.data;
            this.getServiceAmounts(this.cx3Supports, "support");
            this.setNewSupportPrice();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching 3CX Support Packages", error);
          }
        );
    },

    setNewPrice() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/new/price/Cx3CloudPbxPackagePrice"
        )
        .then(
          (response) => {
            this.newPrice = response.data;
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Price Template", error);
          }
        );
    },
    setNewSupportPrice() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/new/price/PbxSupportPackagePrice"
        )
        .then(
          (response) => {
            this.newSupportPrice = response.data;
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Support Price Template", error);
          }
        );
    },

    openPriceModal(cx3Package) {
      this.rowPrice = this.deepCopyObject(
        cx3Package.prices || []
      );
      this.newPrice.cx3CloudPbxPackageNumber = cx3Package.cx3CloudPbxPackageNumber;
      this.$refs.addPriceModal.open();
    },
    openSupportPriceModal(support) {
      this.rowSupportPrice = this.deepCopyObject(
        support.prices || []
      );
      this.newSupportPrice.pbxSupportPackageNumber = support.pbxSupportPackageNumber;
      this.$refs.addSupportPriceModal.open();
    },

    addPrice(newPrice) {
      this.rowPrice.forEach((price) => {
        if (price.validUntil == 0) {
          price.validUntil = this.decreaseBillingPeriod(newPrice.validFrom);
        }
      });
      this.rowPrice.push(newPrice);
      this.setNewPrice();
      this.newPrice.cx3CloudPbxPackageNumber = newPrice.cx3CloudPbxPackageNumber;
    },
    addSupportPrice(newPrice) {
      this.rowSupportPrice.forEach((price) => {
        if (price.validUntil == 0) {
          price.validUntil = this.decreaseBillingPeriod(newPrice.validFrom);
        }
      });
      this.rowSupportPrice.push(newPrice);
      this.setNewSupportPrice();
      this.newPrice.pbxSupportPackageNumber = newPrice.pbxSupportPackageNumber;
    },

    editPackage(cx3Package) {
      this.pricePackage = this.deepCopyObject(cx3Package);
      this.$refs.modifyPackageModal.open();
    },
    editSupport(support) {
      this.priceSupportPackage = this.deepCopyObject(support);
      this.$refs.modifySupportPackageModal.open();
    },

    createNewPackage() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/new/package/Cx3CloudPbxPackage"
        )
        .then(
          (response) => {
            this.pricePackage = response.data;
            this.pricePackage.productNumber = this.productNumber;
            this.$refs.modifyPackageModal.open();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Package Template", error);
          }
        );
    },
    createNewSupport() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/new/package/PbxSupportPackage"
        )
        .then(
          (response) => {
            this.priceSupportPackage = response.data;
            this.priceSupportPackage.productNumber = this.productNumber;
            this.$refs.modifySupportPackageModal.open();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Support Template", error);
          }
        );
    },

    packageAdded(cx3Package) {
      this.cx3Packages.push(cx3Package);
      this.openPriceModal(cx3Package);
    },
    supportAdded(support) {
      this.cx3Supports.push(support);
      this.openSupportPriceModal(support);
    },

    deletePackage(cx3package) {
      this.$swal({
        title: "Are you sure you want to delete this Package?",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(
              this.$config.aimsAPI +
                "pricing/pricepackages/" +
                cx3package.objKey +
                "?objClassName=" +
                cx3package.class
            )
            .then(
              (response) => {
                this.showSuccess(response.data.message);
                this.loadCx3Packages();
                this.loadCx3Supports();
              },
              (error) => {
                this.showError("Error Deleting Price Package", error);
              }
            );
        }
      });
    },

    getServiceAmounts: function(data, type) {     
      const hostUrl = this.$config.aimsAPI;  
      this.$http.post(`${hostUrl}pricing/voiceservices/amount`, data).then(
        (response) => {
          if (type == "main") {
            this.cx3PackageData = response.data
          } else if (type == "record") {
            this.cx3RecordData = response.data
          } else if (type == "support") {
            this.cx3SupportData = response.data
          }    
        },
        (error) => {
          this.showError("Error fetching package sales data", error);
          console.error(error);
        }
      );     
    },
    packageAmount(packageData) {
      const match = (this.cx3PackageData || []).find(
        data => data.cx3CloudPbxPackageNumber === packageData.cx3CloudPbxPackageNumber
      );
      return match ? match.sales : 0;
    },
    supportAmount: function(packageData) {
      const match = (this.cx3SupportData || []).find(
        data => data.pbxSupportPackageNumber === packageData.pbxSupportPackageNumber
      );
      return match ? match.sales : 0;
    },
  },
};
</script>
